export default "__VITE_ASSET__DzfyhVn3__"